import { render, staticRenderFns } from "./dropdown_button_text.vue?vue&type=template&id=2554353f&"
import script from "./dropdown_button_text.vue?vue&type=script&lang=js&"
export * from "./dropdown_button_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports